import BaseService from "src/packages/BaseService";

export default class LotteryService extends BaseService {
	static get className() {
		return "lottery";
	}
};
